import React from 'react';
import { AboutContainer } from '../../container';

const AboutPage = () => {
  return (
    <>
      <AboutContainer />
    </>
  );
};

export default AboutPage;
